// extracted by mini-css-extract-plugin
export default {"newClassName":"style_newClassName__zEGfu","content":"style_content__iOOR3","tab":"style_tab__G5-ul","text":"style_text__hhUjH","loading":"style_loading__h0NJF"};